import styled from 'styled-components';
import {  MagstimColor, CurrentTheme } from "common";

import styledMagstimTableWrapper from './StyledMagstimTableWrapper'

const styledMagstimTabsWrapper = styled(styledMagstimTableWrapper)`

.header-area {
	font-family: 'Montserrat', -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif !important;
	font-size: ${CurrentTheme().MagstimNavBarFontSize};
	color: ${MagstimColor.MagstimTextForground};
}
	
.notes-area {

	textarea { resize: none; }

	.ui-scroll {
			overflow: auto;
			margin-top: 20px;
			height: calc(100vh - 62vh);
	}cd p
	.ui-scroll::-webkit-scrollbar, .ui-scroll textarea::-webkit-scrollbar  {
		width:20px; /*  manage scrollbar width here */
	}
	.ui-scroll::-webkit-scrollbar-track, .ui-scroll textarea::-webkit-scrollbar-track  {
		-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
		border-radius: 0;
	}
	.ui-scroll::-webkit-scrollbar-thumb, .ui-scroll textarea::-webkit-scrollbar-thumb {
		background-color: ${MagstimColor.MagstimPrimaryBlue}; /* manage scrollbar thumb background color here */
		border-radius: 0;
	}	

	.container-fluid {
		padding-bottom: 15px;
	}

	.btn {
		width: 100%;
		margin-bottom: 15px;
		box-shadow: 0px 2px 5px rgba(0,0,0,0.2);
	}
}

.tab-content .tab-pane {
	padding-top: 0.5rem;
	padding-left: 1rem;
	padding-right: 0rem;
}

.sect-tabs {
		margin: 0;
		padding: 0;
		text-align: center;
	
		}
		.tab-content {
			background-color:transparent;
			border-color: transparent;
		}

		.nav-tabs .nav-link {
			color: ${MagstimColor.MagstimButtonText};
			font-size:${CurrentTheme().MagstimNavBarFontSize};
			&:hover {
				color: ${MagstimColor.MagstimPrimaryBlue};
			}
		}
		.nav-tabs .nav-link.disabled {
			color: ${MagstimColor.MagstimWhite};
			background-color: transparent;
			border-color: transparent;
			font-weight: bold;
		}
		.nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active {
			color: ${MagstimColor.MagstimPrimaryBlue};
			background-color: transparent;
			border-color: transparent;
			font-weight: bold;
		}
	}

.btn span.icon {
	float: left;
	padding-left: 6px;
}
`
export default styledMagstimTabsWrapper;